import { IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonRippleEffect, IonRow, IonSkeletonText, IonTitle, IonToolbar, useIonRouter } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import { chevronForward } from "ionicons/icons";
import React, { useCallback, useEffect } from "react";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import { ApiService } from "../../services";

const SelectMemberType = (props: any) => {
  const router = useIonRouter();
  const { data, isLoading } = useQuery({
    queryKey: ["member-ty[es"],
    queryFn: () => {
      return ApiService.get("member-types");
    },
  });

  const proceed = useCallback(
    (memberType: any) => {
      router.push(`/register/${memberType.id}/${memberType.name}`);
    },
    [router],
  );

  useEffect(() => {
    if (!isLoading) {
      if (data.data && data.data.length === 1) {
        proceed(data.data[0]);
      }
    }
  }, [isLoading, data, router, proceed]);

  return (
    <BasicTemplate className={`page--select-member-type`} hideBackButton={false} hideHeader={false} title={t("register") || ""}>
      <IonContent className={"ion-padding"}>
        <IonHeader collapse={"condense"}>
          <IonToolbar>
            <IonTitle slot={"start"} size={"large"}>
              {t("register")}
            </IonTitle>
          </IonToolbar>
        </IonHeader>

        <div className={"member-types-list"}>
          <p className={"description-after-header"}>{t("selectMemberType")}</p>
          {isLoading
            ? [0, 1, 2, 3].map((i) => (
                <div key={`skeleton-text-${i}`} className={"ion-activatable ripple-parent rounded-rectangle"}>
                  <IonSkeletonText
                    animated
                    style={{
                      width: "65%",
                      height: "24px",
                    }}
                  />

                  <IonSkeletonText
                    animated
                    style={{
                      // A random number between 40 and 90%
                      width: `${Math.floor(Math.random() * 50) + 40}%`,
                    }}
                  />
                </div>
              ))
            : data &&
              data.data?.map((memberType: any) => (
                <div
                  key={`member-type-${memberType.id}`}
                  className={"ion-activatable ripple-parent rounded-rectangle"}
                  onClick={() => {
                    proceed(memberType);
                  }}
                >
                  <IonGrid
                    style={{
                      width: "100%",
                      padding: 0,
                    }}
                  >
                    <IonRow>
                      <IonCol size={"11"}>
                        <IonLabel
                          className={"block"}
                          style={{
                            fontWeight: "bold",
                          }}
                        >
                          {memberType.name}
                        </IonLabel>
                        <IonLabel
                          className={"block ion-text-wrap"}
                          style={{
                            fontSize: "0.8em",
                          }}
                        >
                          {memberType.description || t("selectThisOptionToRegisterAsA") + " " + memberType.name + "."}
                        </IonLabel>
                      </IonCol>

                      <IonCol
                        size={"1"}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <IonIcon icon={chevronForward} />
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                  <IonRippleEffect></IonRippleEffect>
                </div>
              ))}
        </div>
      </IonContent>
    </BasicTemplate>
  );
};

export default SelectMemberType;
